// Icon Manager for domain-specific icons (JPG/PNG only)
export class IconManager {
  constructor() {
    this.iconCache = new Map();
    this.supportedExtensions = ['jpg', 'jpeg', 'png'];
  }

  // Find icon with format detection
  findIconWithFormat(iconPath) {
    if (!iconPath) return null;

    // If path already has extension, return as is
    if (iconPath.includes('.')) {
      const ext = iconPath.split('.').pop().toLowerCase();
      if (this.supportedExtensions.includes(ext)) {
        return iconPath;
      }
    }

    // Try different extensions in priority order
    const basePath = iconPath.replace(/\.[^/.]+$/, '');
    const extensions = ['png', 'jpg', 'jpeg']; // PNG first, then JPG

    // Return the first extension (PNG) - the component will handle existence checking
    return `${basePath}.${extensions[0]}`;
  }

  // Get domain-specific icon
  getDomainIcon(domainId) {
    if (!domainId) {
      return this.findIconWithFormat('/assets/icons/default');
    }

    // Check cache first
    if (this.iconCache.has(domainId)) {
      return this.iconCache.get(domainId);
    }

    const iconPath = this.findIconWithFormat(`/assets/icons/${domainId}`);
    
    
    // Cache the result
    this.iconCache.set(domainId, iconPath);
    
    return iconPath;
  }

  // Get icon with fallback
  getIconWithFallback(domainId, fallbackIcon = '/assets/icons/default') {
    const iconPath = this.getDomainIcon(domainId);
    const fallbackPath = this.findIconWithFormat(fallbackIcon);
    
    return {
      src: iconPath,
      alt: `${domainId} icon`,
      onError: (event) => {
        if (event.target.src !== fallbackPath) {
          event.target.src = fallbackPath;
        }
      }
    };
  }

  // Clear cache
  clearCache() {
    this.iconCache.clear();
  }
}

// Create singleton instance
export const iconManager = new IconManager();
